import { useResource } from '@/hooks/useResource'
import { getCustomerDetailByIdApi } from '@/apis/customerManage'
import { useRouter } from 'vue-router'

interface authData {
  objectId: string // 客户id
  realName: string
  tableCode?: string
  source?: string
  [key: string]: any
}
export function useJumpAuth() {
  const { getMenuAuth, getMenuId } = useResource()
  const router = useRouter()
  const customerMenuId = getMenuId({ code: 'CustomerManage' })
  const ClueMenuId = getMenuId({ code: 'ClueManage' })

  // 跳转 线索管理 详情
  function jumpToClueDetail(data: authData) {
    if (!getMenuAuth('ClueManage')) {
      ElMessage.error('暂无权限，请联系管理员开通权限')
      return
    }
    getCustomerDetailByIdApi(
      { shopOrderId: data?.objectId, tableCode: data?.tableCode },
      { MenuId: ClueMenuId }
    )
      .then(res => {
        console.log('跳转详情', res)
        if (res && res.id) {
          router.push(
            `/clueDetail?id=${data?.objectId}&tableCode=${data?.tableCode}&outPerms=false&realName=${data?.realName}&appCode=${data?.appCode}`
          )
        } else {
          ElMessage.error('暂无权限，请联系管理员开通权限')
        }
      })
      .catch(err => {
        console.log(err, '错误')
        ElMessage.error('暂无权限，请联系管理员开通权限')
      })
  }

  // 跳转 客户管理 详情
  function jumpToCustomerDetail(data: authData) {
    if (!getMenuAuth('CustomerManage')) {
      ElMessage.error('暂无权限，请联系管理员开通权限')
      return
    }
    console.log(customerMenuId, 'customerMenuId')
    // return
    const tableCode = data.tableCode ? data.tableCode : '9c99f25a97f34da4858ea60c8adb8d'
    getCustomerDetailByIdApi({ shopOrderId: data?.objectId, tableCode }, { MenuId: customerMenuId })
      .then(res => {
        console.log('跳转详情', res)
        if (res && res.id) {
          router.push(
            data.source
              ? `/customerDetail?id=${data?.objectId}&tableCode=${tableCode}&outPerms=false&realName=${data?.realName}&source=${data?.source}&appCode=${data?.appCode}`
              : `/customerDetail?id=${data?.objectId}&tableCode=${tableCode}&outPerms=false&realName=${data?.realName}&appCode=${data?.appCode}`
          )
        } else {
          ElMessage.error('暂无权限，请联系管理员开通权限')
        }
      })
      .catch(err => {
        console.log(err, '错误')
        ElMessage.error('暂无权限，请联系管理员开通权限')
      })
  }

  // 跳转 公海 详情
  function jumpToSeaDetail(data: authData) {
    if (!getMenuAuth('HighSeaManage')) {
      return ElMessage.error('暂无权限，请联系管理员开通权限')
    }
    const tableCode = data.tableCode ? data.tableCode : '8f33517227b9449088956e298be02c'
    router.push(
      data.source
        ? `/highSeaDetail?id=${data?.objectId}&tableCode=${tableCode}&outPerms=false&realName=${data?.realName}&source=${data?.source}&appCode=${data?.appCode}`
        : `/highSeaDetail?id=${data?.objectId}&tableCode=${tableCode}&outPerms=false&realName=${data?.realName}&appCode=${data?.appCode}`
    )
  }

  // 跳转 回收站 详情
  function jumpToRecyleDetail(data: authData) {
    if (!getMenuAuth('RecycleBin')) {
      return ElMessage.error('暂无权限，请联系管理员开通权限')
    }
    const tableCode = data.tableCode ? data.tableCode : '03a12655549c436796b6676e7471s7'

    router.push(
      data.source
        ? `/recycleBinDetail?id=${data?.objectId}&tableCode=${tableCode}&outPerms=false&realName=${data?.realName}&source=${data?.source}&appCode=${data?.appCode}`
        : `/recycleBinDetail?id=${data?.objectId}&tableCode=${tableCode}&outPerms=false&realName=${data?.realName}&appCode=${data?.appCode}`
    )
  }

  return { jumpToClueDetail, jumpToCustomerDetail, jumpToSeaDetail, jumpToRecyleDetail }
}
